var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Col, Row } from "@irati/ui/src/ColumnRow";
import { Body } from "@irati/ui/src/Typography";
import Expand from "@irati/ui/src/Expander";
import { injectIntl, FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
var VAT = function (_a) {
    var net = _a.net, vat = _a.vat, formatMessage = _a.formatMessage, currency = _a.currency;
    return (React.createElement("div", { className: "orderSummaryVAT" },
        React.createElement(Expand, { HeaderLabel: function (props) { return React.createElement(Body, __assign({ small: true, weight: "bold", color: "ink" }, props)); }, showText: formatMessage({ id: "perks.components.orderSummary.vat.vatSummary" }) },
            React.createElement(Row, { paddingTop: 1 },
                React.createElement(Col, { xs: 10 },
                    React.createElement(Body, { small: true },
                        React.createElement(FormattedMessage, { id: "perks.components.orderSummary.vat.netAmount" }))),
                React.createElement(Col, { xs: 2 },
                    React.createElement("div", { className: "pull-right" },
                        React.createElement(Body, { small: true },
                            React.createElement(FormattedCurrency, { currency: currency, value: net }))))),
            React.createElement(Row, { paddingTop: 1 },
                React.createElement(Col, { xs: 10 },
                    React.createElement(Body, { small: true },
                        React.createElement(FormattedMessage, { id: "perks.components.orderSummary.vat.vat" }))),
                React.createElement(Col, { xs: 2 },
                    React.createElement("div", { className: "pull-right" },
                        React.createElement(Body, { small: true },
                            React.createElement(FormattedCurrency, { currency: currency, value: vat })))))),
        React.createElement("hr", null)));
};
export default injectIntl(VAT);
